import styles from "../orders-page.module.scss";
import { Space, Table, Typography } from "antd";
import ordersStorage from "../../../storages/orders.storage";
import DetailTable from "../components/detailTable";
import { observer } from 'mobx-react-lite';
import { useState } from "react";

function Tracking() {
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <Table
      rowKey="trackNumber"
      className={styles['tableMiddle']}
      columns={[
        {
          title: "Tracking",
          dataIndex: "trackNumber",
          key: "trackNumber",
          render: (value: string, rowData) => {
            return (
              <Space direction={"vertical"}>
                <Typography>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://www.aliexpress.com/p/tracking/index.html?tradeOrderId=${rowData.orders?.[0]?.orderId}`}
                  >
                    {value}
                  </a>
                </Typography>
              </Space>
            )
          }
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          render: (value: string) => {
            return (
              <Space direction={"vertical"}>
                <Typography>{value}</Typography>
              </Space>
            )
          }
        },
        {
          title: "Orders in package",
          dataIndex: "o",
          key: "o",
          render: (value: string, rowData) => {
            return (
              <Space direction={"vertical"}>
                <Typography>{rowData.orders?.length}</Typography>
              </Space>
            )
          }
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          render: (value: string, rowData) => {
            const dates = [...new Set(rowData.orders?.map(order => order.orderDate.toISOString()) || [])];
            return (
              <Space direction={"vertical"}>
                <Typography>{dates.map(date => date.substring(0, 10)).join(', ')}</Typography>
              </Space>
            )
          }
        },
        {
          title: "Tracking status",
          dataIndex: "t",
          key: "t",
          render: (value: string, rowData) => {
            const statuses = [...new Set(rowData.orders?.map(order => order.trackingStatus) || [])];
            return (
              <Space direction={"vertical"}>
                <Typography>{statuses.join(',')}</Typography>
              </Space>
            )
          }
        },
        {
          title: "Recipient",
          dataIndex: "address",
          key: "address",
          render: (value: string, rowData) => {
            return (
              <Space direction={"vertical"}>
                <Typography>{value?.split(/\s/)?.slice(0,2)?.join(" ")}</Typography>
              </Space>
            )
          }
        },
      ]}
      dataSource={ordersStorage.tracking}
      pagination={
        {
          position: ['bottomCenter'],
          // pageSize: 20,
          current: currentPage,
          onChange: (page) => {
            setCurrentPage(page);
          }
        }
      }
      expandable={{
        expandedRowRender: (item,  index, indent, expanded) => {
          console.log(item);
          return (
            expanded && item.orders?.filter(Boolean).map(order => {
              const currentOrder = ordersStorage.orders.find((o) => o.orderId === order.orderId);
              if (!currentOrder) return null;
              return (
                <>
                  <Typography>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.aliexpress.com/p/order/detail.html?orderId=${order.orderId}`}
                    >
                      {order.orderId}
                    </a> / {order.trackingStatus}
                  </Typography>
                  <DetailTable order={currentOrder} key={order._id}/>
                </>
              )
            })
          );
          // return null;
        },
        rowExpandable: (record) => {
          return record.orders?.length > 0;
        },
        // defaultExpandedRowKeys: expandedRowKeys,
        // expandedRowKeys: expandedRowKeys,
        onExpandedRowsChange: (expandedRows) => {
          console.log("expandedRows", expandedRows);
        },
        onExpand: (expanded, record) => {
          // expandTrackingRow(record.trackNumber, expanded);
        }
      }}
    />
  );
}

export default observer(Tracking);
